<script setup lang="ts">
import type { Follower } from '@/types/profile';

const props = defineProps({
	follower: {
		type: Object as PropType<Follower>,
		default: () => {},
		required: true,
	},
	isLoading: {
		type: Boolean,
		default: false,
	},
	hideCheckbox: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits<{
	(e: 'onChange', isSelect: boolean, userId: number): void;
}>();

const profileStore = useProfileStore();
const router = useRouter();

const isAdmin = computed(
	() => props.follower.role === GROUP_ROLE.ADMIN || props.follower.role === GROUP_ROLE.OWNER
);

const isChecked = ref<boolean>(isAdmin.value);
const checkboxRef = ref();

function handleNavigation(id: number) {
	if (id === profileStore.profile?.id) {
		router.push({
			name: ROUTE.PROFILE.NAME,
		});
	} else {
		router.push({
			name: ROUTE.USER.NAME,
			params: {
				id,
			},
		});
	}
}

function handleOnChange(isSelect: boolean) {
	emit('onChange', isSelect, props.follower.id);
}
</script>

<template>
	<div class="follower-item-container text-sm text-medium">
		<BaseButton class="follower" variant="link" color="gray" @click="handleNavigation(follower.id)">
			<AvatarImage :image-url="follower.avatar" :alt="follower.nickname" />
			<p class="text-md text-medium">
				{{ follower.nickname }}
			</p>
		</BaseButton>
		<BaseCheckbox
			v-if="!hideCheckbox"
			:id="`follower-id-${follower.id}`"
			ref="checkboxRef"
			v-model="isChecked"
			:name="`follower-${follower.id}`"
			:disabled="isLoading || isAdmin"
			@on-change="handleOnChange"
		/>
	</div>
</template>

<style scoped lang="scss">
.follower-item-container {
	display: flex;
	justify-content: space-between;
	align-items: center;

	:deep(.checkmark) {
		width: spacings-get(5);
		height: spacings-get(5);
	}

	.follower {
		display: grid;
		grid-template-columns: spacings-get(10) 1fr;
		align-items: center;
		justify-items: start;
		column-gap: spacings-get(3);
		padding: spacings-get(3) spacings-get(6) spacings-get(3) 0;
		color: colors-get(gray, 900);

		p {
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			text-align: left;
		}
	}
}
</style>
